

import CryptoJS from "crypto-js";

export function decryptAesZeroPadding(encryptedBase64) {
  const keyString = "350539CAEF80453A";
  const ivString  = "0000000000000000";

  
  const key = CryptoJS.enc.Utf8.parse(keyString);
  const iv = CryptoJS.enc.Utf8.parse(ivString);


  const encryptedCipherParams = {
    ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64),
  };

  const decrypted = CryptoJS.AES.decrypt(
    encryptedCipherParams,
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding,
    }
  );

  let decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

  decryptedText = decryptedText.replace(/\0+$/, "");

  return decryptedText;
}
